import React from "react";
import PillWithIconFake from "../../pill-with-icon-fake";
import style from "./style";

const FakeMyProducts = ({ withoutContainer }) => {
  return (
    <div className={withoutContainer ? "" : "container"}>
      <div className="menu">
        <PillWithIconFake />
        <PillWithIconFake />
        <PillWithIconFake />
        <PillWithIconFake />
        <PillWithIconFake />
        <style jsx>{style}</style>
      </div>
    </div>
  );
};

export default FakeMyProducts;
